<template>
<!-- 拍品推荐 -->
<div class="page" v-if="recoData.length">
    <h3 class="columnTit"><span>拍品推荐</span></h3>
    <div class="topSwiper">
        <el-carousel height="870px" indicator-position="outside" :autoplay="false" arrow="always">
            <el-carousel-item v-for="(item, index) in recoData" :key="index">
                <div class="topSwiper_outbox">
                    <div class="outbox_item" v-for="(m, i) in item" :key="i">

                        <div class="topswperitem_img" @click="authorClick(m)">
                            <router-link :to="{path:'/paimai-'+m.ArtCode}" target="_blank">
                                <img :src="m.Cover" alt="" />
                            </router-link>
                        </div>
                        <div class="topswperitem_title" @click="authorClick(m)">
                            <router-link :to="{path:'/paimai-'+m.ArtCode}" target="_blank">{{m.TlNumber}} {{m.Title}}</router-link>
                        </div>
                        <div class="flagLabel">
                            <template v-if="m.live_info.label_list.length">
                                <template v-for="(con,k) in m.live_info.label_list">
                                    <span :key="k" v-if="con.name=='同步拍'">{{con.name}}</span>
                                    <span :key="k" v-if="con.name=='图文直播'">{{con.name}}</span>
                                    <span :key="k" v-if="con.name=='视频直播'">{{con.name}}</span>
                                </template>
                            </template>
                        </div>
                        <div class="topswperitem_gujia">
                            <template v-if="aucstatus == 0 || aucstatus == 1">
                                <div class="gujia">
                                    <span>{{aucstatus == 1 ? '成交价：' : '估价：'}}</span>
                                    <template v-if="aucstatus == 1">
                                        <span class="gujia_content" style="color: #f5222d" v-if="isLogin&&isMem==1">
                                            <template v-if="m.Status == 0&&m.CurrencyPrice!=0">
                                                {{m.CurrencyType}} {{formatMoney(m.CurrencyPrice)}}
                                            </template>
                                            <template v-else-if="m.Status == 1">撤拍</template>
                                            <template v-else-if="m.Status == 2">流拍</template>
                                            <template v-else>未提供</template>
                                        </span>
                                        <!-- <template v-else-if="m.Status == 1">{{m.CurrencyType}}****</template>
                                            <template v-else-if="m.Status == 2">{{m.CurrencyType}}****</template>
                                            <template v-else-if="m.Status == 3">{{m.CurrencyType}}****</template> -->

                                        <a v-else href="javascript:;" @click="gotoLogin">
                                            <template v-if="m.Status != 3&&m.CurrencyPrice!=0">
                                                {{m.CurrencyType}}&nbsp;{{formatPriceTologin(m.CurrencyPrice)}}
                                            </template>
                                            <template v-else>
                                                未提供
                                            </template>
                                        </a>
                                    </template>
                                    <template v-else>
                                        <span class="gujia_content" style="color: #f5222d">
                                            <template v-if="m.EvaluationType == 0">
                                                {{m.CurrencyType}} {{formatMoney(m.OriginalEvaluation)}}<template v-if="m.LastEvaluation > m.OriginalEvaluation">-{{formatMoney(m.LastEvaluation)}}</template>
                                            </template>
                                            <template v-else-if="m.EvaluationType == 1">无底价</template>
                                            <template v-else-if="m.EvaluationType == 2">咨询价</template>
                                            <template v-else-if="m.EvaluationType == 3">估价待定</template>
                                        </span>
                                    </template>
                                </div>
                            </template>
                            <template v-else>
                                <div class="gujia">
                                    <span>{{m.AuctionStatus == 1 ? '成交价：' : '估价：'}}</span>
                                    <template v-if="m.AuctionStatus == 1">
                                        <span class="gujia_content" style="color: #f5222d" v-if="isLogin&&isMem==1">
                                            <template v-if="m.Status == 0&&(m.CurrencyPrice!=0)">
                                                <template v-if="m.AuctionStatus == 1">
                                                        {{m.CurrencyType}}&nbsp;{{formatMoney(m.CurrencyPrice)}}
                                                </template>
                                                 <template v-else>
                                                      {{m.CurrencyType}} {{formatMoney(m.OriginalEvaluation)}}<template v-if="m.LastEvaluation > m.OriginalEvaluation">-{{formatMoney(m.LastEvaluation)}}</template>
                                                </template>

                                            </template>
                                            <template v-else-if="m.Status == 1">撤拍</template>
                                            <template v-else-if="m.Status == 2">流拍</template>
                                            <template v-else>未提供</template>
                                        </span>

                                        <!-- <template v-else-if="m.Status == 1"> {{m.CurrencyType}}****</template>
                                            <template v-else-if="m.Status == 2">{{m.CurrencyType}}****</template>
                                            <template v-else-if="m.Status == 3">{{m.CurrencyType}}****</template>
                                        </span> -->
                                        <a v-else href="javascript:;" @click="gotoLogin">
                                            <template v-if="m.Status != 3&&m.CurrencyPrice != 0">
                                                {{m.CurrencyType}}&nbsp;{{formatPriceTologin(m.CurrencyPrice)}}
                                            </template>
                                            <template v-else>
                                                未提供
                                            </template>
                                        </a>
                                    </template>
                                    <template v-else>
                                        <span class="gujia_content" style="color: #f5222d">
                                            <template v-if="m.EvaluationType == 0">
                                                {{m.CurrencyType}} {{formatMoney(m.OriginalEvaluation)}}<template v-if="m.LastEvaluation > m.OriginalEvaluation">-{{formatMoney(m.LastEvaluation)}}</template>
                                            </template>
                                            <template v-else-if="m.EvaluationType == 1">无底价</template>
                                            <template v-else-if="m.EvaluationType == 2">咨询价</template>
                                            <template v-else-if="m.EvaluationType == 3">估价待定</template>
                                        </span>
                                    </template>
                                </div>
                            </template>
                            <div class="gujia">
                                <span>城市：</span>
                                <span class="gujia_content">{{m.City}}</span>
                            </div>
                            <div class="gujia">
                                <span>日期：</span>
                                <span class="gujia_content">{{m.Date}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</div>
</template>

<script>
import {
    getRecoAuction
} from "@/api/product";
import {
    getMemType
} from "@/api/auction";
// 神策埋点
import {
    authorClick
} from '@/utils/buriedPoint.js'
export default {
    props: ["type", 'isLogin', 'aucstatus', 'session'],
    data() {
        return {
            recoData: [],
            isMem: 0,
            t:0
        };
    },
    mounted() {
        this.t = Date.now()
        this.getRecoAuction();
        this.getMemType()
    },
    methods: {
        getMemType() {
            getMemType().then((res) => {
                if (res.code == 0) {
                    this.isMem = res.data.isMember
                }
            })
        },
        formatPriceTologin(num) {
            // if (num == 0) {
            //     return "****"
            // }
            // let str = (num + '').substring(0, 1);
            // return str + "***";
            return "****"
        },
        authorClick(item) {
            authorClick(item.Id, item.Title)
            console.log('艺术点击', item.Id, item.Title);
        },
        getRecoAuction() {
            let parmas = {}
            if (this.session) {
                parmas = {
                    session_code: this.session
                }
            }
            if (this.aucstatus == 0 || this.aucstatus == 1 || this.aucstatus == 4) {
                parmas = {
                    status: this.aucstatus
                }
            }
            getRecoAuction(parmas).then((res) => {
                if (res.code == 0) {
                    this.recoData = res.data.list
                    this.recoData = this.group(this.recoData, 8)
                }
            })
        },
        group(arr, length) {
            let index = 0;
            let newArray = [];
            while (index < arr.length) {
                newArray.push(arr.slice(index, index += length));
            }
            return newArray;
        },
        gotoLogin() {
            if (!this.isLogin) {
                window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
            }else  if (this.isMem != 1) {
                window.location.href = 'https://member.artron.net/memCenter/collect?business_id=50001&source_page=6&sourceReferer='+encodeURIComponent(window.location.href);
            }

        },
        formatMoney(number) {
            let decimals = 0,
                decPoint = '.',
                thousandsSep = ','
            number = (number + '').replace(/[^0-9+-Ee.]/g, '')
            let n = !isFinite(+number) ? 0 : +number
            let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
            let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
            let dec = (typeof decPoint === 'undefined') ? '.' : decPoint
            let s = ''
            let toFixedFix = function (n, prec) {
                let k = Math.pow(10, prec)
                return '' + Math.ceil(n * k) / k
            }
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
            let re = /(-?\d+)(\d{3})/
            while (re.test(s[0])) {
                s[0] = s[0].replace(re, '$1' + sep + '$2')
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || ''
                s[1] += new Array(prec - s[1].length + 1).join('0')
            }
            return s.join(dec)
        },
    },
};
</script>

<style lang="scss" scoped>
@import url("../../../assets/css/reset.css");

.allyesAdvWrap {
    width: 1180px;
    margin: auto;
}

.columnTit {
    width: 1180px;
    margin: auto;
}

/*排行榜*/
.topSwiper {
    position: relative;
    width: 1180px;
    margin: 0 auto;

    /deep/.el-carousel__container {
        z-index: 3;
    }

    /deep/.el-carousel--horizontal {
        padding-top: 50px;
        margin-top: -50px;
    }

    /deep/.el-carousel__indicators--outside {
        position: absolute;
        top: 3px;
        right: 74px;
        left: inherit;

        .el-carousel__indicator--horizontal {
            padding: 0;
            margin-left: 10px;

            .el-carousel__button {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: #f2f2f2;
                opacity: 1;
            }
        }

        .el-carousel__indicator.is-active button {
            background-color: #329d15;
        }
    }

    /deep/.el-carousel__arrow {
        width: 20px;
        height: 20px;
        background-color: #329d15;
        top: -46px;
        transform: translateY(0);
        display: block !important;
    }

    /deep/.el-carousel__arrow:hover {
        background-color: #5BB144;
    }

    /deep/.el-carousel__arrow--left {
        left: inherit;
        right: 34px;
    }

    /deep/.el-carousel__arrow--right {
        right: 0;
    }

    .topSwiper_outbox {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;

        .outbox_item {
            width: 24%;
            margin-right: 15px;
            margin-bottom: 20px;

            .topswperitem_img {
                // width: 280px;
                height: 280px;
                overflow: hidden;
                border-radius: 4px;
                background-color: #f2f2f2;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;

                    transition: 0.2s transform ease-in-out;
                }

                img:hover {
                    transform: scale(1.1);
                    cursor: pointer;
                }
            }

            .topswperitem_title {
                width: 280px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 18px;
                font-family: MicrosoftYaHei;
                color: #262626;
                line-height: 26px;
                padding: 10px 0px;
            }

            .flagLabel {
                height: 18px;

                span {
                    border: 1px solid #D9D9D9;
                    display: inline-block;
                    font-size: 12px;
                    padding: 0 4px;
                    color: #8C8C8C;
                    border-radius: 4px;
                    margin-right: 6px;
                    height: 18px;
                    line-height: 14px;
                }

                span:last-child {
                    margin-right: 0;
                }
            }

            .topswperitem_gujia {
                margin-top: 10px;

                .gujia {
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    color: #8c8c8c;
                    word-break: break-all;

                    .gujia_content {
                        font-size: 14px;
                        font-family: MicrosoftYaHei;
                        color: #262626;
                    }
                }

                .gujia span:first-child {
                    display: inline-block;
                    margin-bottom: 4px;
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    color: #8c8c8c;
                }
            }
        }

        .outbox_item:nth-child(4n) {
            margin-right: 0;
        }
    }
}
</style>
